import moment from 'moment';

import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row, Button } from 'reactstrap';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import TableContainer from '../../../../Components/Common/TableContainer';
import { CsvExport } from '../../../../Components/Custom/CsvExport';
import ExportCSVModal from '../../../../Components/Custom/ExportCSVModal';
import { PageHeader } from '../../../../Components/Custom/PageHeader';
import { Pagination } from '../../../../Components/Custom/pagination';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { paramsForExport, setDocumentTitle } from '../../../../helpers/helpers';

import { columns } from './columns';
import { Filters } from './filters';
import {
  exportHeaders,
  exportPackageOrders,
  getFuturaMiningOrders,
  getPackageOrders,
  removePackageOrdersForExport
} from '../slice';
import { getUserFromLS } from '../../../../helpers/localstorage-helper';
import { CreateOrderModal } from '../actions/createOrder';

const PAGE_TITLE = 'Futura Mining Orders';

const INITIAL_PARAMS: {
  //   sortBy: string;
  //   sortOrder: string;
  countPerPage: string;
  numberOfPage: string;
} = {
  //   sortBy: 'dateCreated',
  //   sortOrder: 'DESC',
  countPerPage: '10',
  numberOfPage: '1'
};

const FuturaMining = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams(INITIAL_PARAMS);

  const { loading, data, totalCount, dataForExport } = useAppSelector(
    (state) => state.packageOrders
  );

  const [csvModal, setCsvModal] = useState(false);
  const [createOrderModal, setCreateOrderModal] = useState(false);

  const [id, setId] = useState<any>();
  const [product, setProduct] = useState<any>();

  useEffect(() => {
    dispatch(getFuturaMiningOrders(searchParams));
  }, [searchParams]);

  setDocumentTitle(PAGE_TITLE);

  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title={PAGE_TITLE} pageTitle='Dashboard' />
        <Row>
          <Col lg={12}>
            <Card id='orderList'>
              <PageHeader
                loading={loading}
                title={PAGE_TITLE}
                initialParams={INITIAL_PARAMS}
                setSearchParams={setSearchParams}
                actions={<></>}
              />
              <CardBody className='pt-0'>
                <Filters params={searchParams} setParams={setSearchParams} />

                <TableContainer
                  columns={columns}
                  data={data}
                  divClass='table-responsive table-card mb-1'
                  tableClass='align-middle table-nowrap'
                  theadClass='table-light text-muted'
                />

                <Pagination
                  totalCount={totalCount}
                  data={data}
                  params={searchParams}
                  setParams={setSearchParams}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ExportCSVModal
        isOpen={csvModal}
        setIsOpen={setCsvModal}
        data={dataForExport}
        fileName='package-orders-data'
      />
      <CreateOrderModal
        isOpen={createOrderModal}
        setIsOpen={setCreateOrderModal}
        setProduct={setProduct}
        product={product}
        setId={setId}
        id={id}
        params={searchParams}
      />
    </div>
  );
};

export default FuturaMining;
